/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {FlatList, Image, Text, TouchableOpacity, View} from 'react-native';
import {styles} from './styles';

const destinationPage: {[key: string]: string} = {
  voyage: 'DetailContratVoyage',
  rapatriement: 'DetailContratRapatriement',
};

export function NotificationListComponent(props: any) {
  const {datas, redirectionPage, navigate} = props;

  const handleMove = ({item}: {item: any}) => {
    if (item?.destinationPage) {
      navigate(item.destinationPage, {
        id: item.subTitle,
        title: item.title,
      });
    } else if (redirectionPage !== 'DetailContrat') {
      navigate(redirectionPage, {
        id: item.idx,
        title: item.title,
      });
    } else {
      navigate('DetailContrat', {
        id: item.idx,
        title: item.title,
        numeroPolice: item.subTitle,
      });
    }
  };

  // TODO: verify type
  const _data = datas.map((e: any) => {
    return {
      destinationPage: destinationPage[e.type] || '',
      title:
        e.title === 'Assistance MAPFRE'
          ? 'Assurance Voyage'
          : e.title === 'RIP' || e.title === 'Assurance Obsèques à Dago'
          ? 'Assurance Obsèques à Dago'
          : e.title,
      subTitle:
        e.type === 'voyage' && e.policyNumber ? e.policyNumber : e.subTitle,
      idx: e.id,
      is_ending: e.is_ending,
      is_avenant: e.isAvenant || false,
    };
  });

  return (
    <View>
      <FlatList
        scrollEnabled={true}
        keyExtractor={item => item.idx.toString()}
        data={_data || []}
        style={{paddingHorizontal: 10}}
        renderItem={({item, index}: {item: any; index: any}) => (
          <View>
            <TouchableOpacity
              style={
                item?.is_ending &&
                item.typeContratPayment !== 'retraite' &&
                !item?.is_avenant
                  ? styles.ListItemInRowWithNotif
                  : styles.ListItemInRow
              }
              key={index}
              onPress={() => {
                handleMove({item});
              }}>
              <View style={{flex: 1}}>
                <View
                  style={{
                    flexDirection: 'row',
                  }}>
                  <Text style={styles.blueH2}>{item.title} </Text>
                  {item.is_ending ? (
                    <View
                      style={{
                        backgroundColor: 'red',
                        width: 30,
                        height: 30,
                        borderRadius: 10,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <Text
                        style={{
                          color: 'white',
                          fontSize: 18,
                        }}>
                        1
                      </Text>
                    </View>
                  ) : null}
                </View>
                <Text style={styles.ListItemFont}>{item.subTitle}</Text>
              </View>
              <View>
                <Image
                  style={styles.ListItemLogo}
                  source={require('../../../ressources/images/Arrow-Right.png')}
                />
              </View>
            </TouchableOpacity>
          </View>
        )}
      />
    </View>
  );
}
